import { RouteConfig } from 'vue-router'
import { integrationsRouteNames } from '@/routes/constants/location'
import { requireAuthAndLocation } from '../auth'

const Integration = () =>
  import('@/pmd/pages/agency/Integration.vue').then(m => m.default)

export const integrationsRoute: RouteConfig[] = [
  {
    path: 'integration',
    name: integrationsRouteNames.default,
    component: Integration,
    beforeEnter: requireAuthAndLocation,
    children: [
      {
        path: ':appId/upgrade-plans',
        name: integrationsRouteNames.appUpgradePlans,
        component: Integration,
        beforeEnter: requireAuthAndLocation,
      },
      {
        path: '*',
        name: integrationsRouteNames.subRoute,
        component: Integration,
        beforeEnter: requireAuthAndLocation,
      },
    ],
  }
]
